<template>
  <div>
    <Heading :layout="{}">
      {{ layout.uberschrift }}
    </Heading>
    <div class="whole row d-none d-md-flex">
      <div class="col-2 inner">
        <a class="box" v-squared target="_blank" href="https://online-termine.meine-praxis.info/DB200206500/index.php?action=st_reg_user_form">
          <div class="icon">

            <img src="@/assets/Icon_Registrierung.svg" alt="">
          </div>
          <div class="name">
            Als Kunde registrieren</div>

        </a>
      </div>
      <div class="col-2 inner">
        <a  class="box" v-squared target="_blank" href="https://online-termine.meine-praxis.info/DB200206500/index.php?action=st_services">
          <div class="icon">

            <img src="@/assets/Icon_Leistungsauswahl.svg" alt="">
          </div>
          <div class="name">Leistung aussuchen</div>

        </a>
      </div>
      <div class="col-2 inner">
        <a class="box" v-squared target="_blank" href="https://online-termine.meine-praxis.info/DB200206500/index.php?action=st_services">
          <div class="icon">

            <img src="@/assets/Icon_Wunschtermin.svg" alt="">
          </div>
          <div class="name">Wunschtermin buchen</div>

        </a>
      </div>
    </div>
    <br>
    <br>
    <div class="whole row">
      <div class="col-8 col-md-4">
        <div v-html="layout.text">

        </div>
        <a target="_blank" href="https://online-termine.meine-praxis.info/DB200206500/" class="button">
          Terminportal öffnen
        </a>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: "Buchungstool",
  components: {
    Heading: () => import('@/components/parts/Heading'),

  },
  props: ['layout']
}
</script>

<style scoped lang="scss">
a {
  color: #fff;
}

.box {
  background-color: $blue;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 80%;
}

.name {
  font-family: $headfont;
  display: flex;
  flex: 0 0 15%;
  line-height: 25px;
  margin-top: 10px;
  font-size: 18px;
  padding-left: 15px;
  padding-right: 15px;
  color: #fff;
  letter-spacing: 0.05em;

}

.icon {
  width: 50%;

  img {
    width: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/Buchungstool.vue